import { render, staticRenderFns } from "./input-passenger.vue?vue&type=template&id=aff5fb4a&"
import script from "./input-passenger.vue?vue&type=script&lang=js&"
export * from "./input-passenger.vue?vue&type=script&lang=js&"
import style0 from "./input-passenger.vue?vue&type=style&index=0&id=aff5fb4a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports